import language from "@/assets/lang/en.json"

export default class Language {

    get (prop: string) {
        // @ts-ignore
        return language[prop] || '';
    }
}